var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarabineros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 835,
    y: -5,
    width: 53,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 362169,
    height: 360000
  })), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 42,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360000,
    height: 360000
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-835 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(9.09327e-05 5.25e-05 -5.25e-05 9.09327e-05 854.527 -4.06852)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1.00602 1.75198e-08 -2.42102e-08 1 0 0)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8571.43 8571.43)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarabineros);
export default __webpack_public_path__ + "static/media/Carabineros.6cd028cec92f7a4e5ecd6be8c6737fa1.svg";
export { ForwardRef as ReactComponent };